"use client";
import "../../../chunk-MMUBH76A.js";
import { jsx } from "react/jsx-runtime";
import { Waiting } from "../Waiting/Waiting.js";
const AwaitingOAuthStep = () => {
  return /* @__PURE__ */ jsx(Waiting, { heading: "Complete Login", subheading: "Follow the prompts presented by your browser." });
};
export {
  AwaitingOAuthStep
};
